import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export const URL = '/api_publica/v1/recursos/recursos';
export const URL_SELECTOR = `${URL}/selector`;

export default {
  URL,
  URL_SELECTOR,
  get(id, options) {
    return cifraClient.get(`${URL}/${id}`, options);
  },
  list(options) {
    return cifraClient.get(`${URL}`, options);
  },
};
